/**
 * HashKey Element Target Id for scroll
 */
export const TargetElementIdMap = {
  PLAYBACK_SECTION: "project-playback",
  CORRECT_RATE_SECTION: "project-correct-rate",
  PERFORMANCE_SECTION: "project-performance",
  READABILITY_SECTION: "project-readability",
} as const satisfies Record<string, string>;
